import type { ReactElement } from 'react';

type Props = {
  retailPrice: string;
  onRetailPriceChange: (v: string) => void;
  costPrice: string;
  onCostPriceChange: (v: string) => void;
};

export function PricingSection({
  retailPrice,
  onRetailPriceChange,
  costPrice,
  onCostPriceChange,
}: Props): ReactElement {
  return (
    <section id="section-pricing" className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-slate-950">Pricing</h2>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className="block">
          <span className="text-sm font-medium">Retail price</span>
          <input
            type="number"
            step="0.01"
            className="mt-1 w-full rounded-xl border px-3 py-2"
            value={retailPrice}
            onChange={(e) => onRetailPriceChange(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Cost price</span>
          <input
            type="number"
            step="0.01"
            className="mt-1 w-full rounded-xl border px-3 py-2"
            value={costPrice}
            onChange={(e) => onCostPriceChange(e.target.value)}
          />
        </label>
      </div>
    </section>
  );
}
